module.exports = __webpack_public_path__ + "img/the-netherlands-breast-cancer-female.41d0349d.png";